import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface WithDynamicTitleProps {}

function withDynamicTitle<P>(
  WrappedComponent: React.ComponentType<P>,
  title: string
) {
  const WithDynamicTitle: React.FC<P & WithDynamicTitleProps> = (props) => {
    const location = useLocation();

    useEffect(() => {
      document.title = `${title} - Booking FrameWork`;
    }, [location.pathname, title]);

    return <WrappedComponent {...props} />;
  };

  return WithDynamicTitle;
}

export default withDynamicTitle;
